(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vision-pairs-well"] && !Shopify.designMode) return;
  try {
    class VisionPairs extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.vision-pairs__scroller');
      this.prevButton = this.querySelector('.vision-pairs__btn--prev');
      this.nextButton = this.querySelector('.vision-pairs__btn--next');
      if (!this.scroller || !this.prevButton || !this.nextButton) return;

      this.prevButton.addEventListener('click', () => this.move(-1));
      this.nextButton.addEventListener('click', () => this.move(1));
      this.scroller.addEventListener('scroll', () => this.sync(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.sync());
      this.resizeObserver.observe(this.scroller);
      this.sync();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    move(direction) {
      const card = this.scroller.querySelector('.vision-pairs__card');
      const amount = card ? card.getBoundingClientRect().width + 10 : this.scroller.clientWidth * 0.85;
      this.scroller.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    sync() {
      const max = this.scroller.scrollWidth - this.scroller.clientWidth - 2;
      this.prevButton.disabled = this.scroller.scrollLeft <= 2;
      this.nextButton.disabled = max <= 0 || this.scroller.scrollLeft >= max;
    }
  }

  if (!customElements.get('vision-pairs')) {
    customElements.define('vision-pairs', VisionPairs);
  }
  } catch(e) { console.error(e); }
})();

})();
